import { render, staticRenderFns } from "./Porfolio2.vue?vue&type=template&id=09d085fd&scoped=true&"
import script from "./Porfolio2.vue?vue&type=script&lang=js&"
export * from "./Porfolio2.vue?vue&type=script&lang=js&"
import style0 from "./Porfolio2.vue?vue&type=style&index=0&id=09d085fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d085fd",
  null
  
)

export default component.exports